export default {
  pickAColor: 'Pick a color',
  color: 'Color',
  alerts: {
    uniqueNameError: 'A category with the same name already exists.'
  }
};
